/** Seeded PRNG (mulberry32). The state is a single uint32 kept inside the owner's state. */

export interface RngHolder {
  rng: number;
}

/** Returns a float in [0, 1) and advances holder.rng. */
export function nextRandom(holder: RngHolder): number {
  let t = (holder.rng = (holder.rng + 0x6d2b79f5) | 0);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

/** Float in [lo, hi). */
export function randomRange(holder: RngHolder, lo: number, hi: number): number {
  return lo + (hi - lo) * nextRandom(holder);
}

/** Derives an independent seed from a seed and a salt (for bots, rounds, …). */
export function deriveSeed(seed: number, salt: number): number {
  let h = (seed ^ Math.imul(salt + 0x9e3779b9, 0x85ebca6b)) | 0;
  h = Math.imul(h ^ (h >>> 16), 0x7feb352d);
  h = Math.imul(h ^ (h >>> 15), 0x846ca68b);
  return (h ^ (h >>> 16)) | 0;
}
